import { Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PermissionCustomer } from "../../../../permissions/PermissionCustomer";
import administratorStore from "../../../../stores/administratorStore";
import customerStore from "../../../../stores/customerStore";
import { convertToDayjs } from "../../../../utils/functions";
import ActionButton from "../../../atoms/ButtonComponent";
import CheckboxComponent from "../../../atoms/CheckboxComponent";
import DatePickerComponet from "../../../atoms/DatePickerComponet";
import InputComponent from "../../../atoms/InputComponet";
import InputMaskComponent from "../../../atoms/InputMaskComponent";
import InputPassword from "../../../atoms/InputPassword";
import NotPermissionComponent from "../../../atoms/NotPermissionComponent";
import SelectComponent from "../../../atoms/SelectComponent";
import ContentBox from "../../../molecules/ContentBox";
import Permission from "../../../molecules/Permission";
import { validationEditSchema, validationSchema } from "./schema";
import SwitchComponent from "../../../atoms/SwitchComponent";

interface DataType {
    zipCode: string;
    street: string;
    block: string;
    number: string;
    state: string;
    city: string;
    key: React.Key;
}


const FormCustomer: React.FC = observer(() => {
    const { uuid } = useParams<{ uuid: string }>();
    const { customer } = customerStore;
    const navigate = useNavigate();
    const { administratorSelect } = administratorStore;

    const defaultGender = (value: string, entity: string) => {
        if (value === "MASCULINO") {
            return {
                label: "Masculino",
                value: "MASCULINO",
            };
        } else if (value === "FEMININO") {
            return {
                label: "Feminino",
                value: "FEMININO",
            };
        } else if (entity === "FISICA") {
            return {
                label: "Feminino",
                value: "FEMININO",
            };
        }
    };

    const defaultEntity = (value: string) => {
        if (value === "FISICA") {
            return {
                label: "Física",
                value: "FISICA",
            };
        } else {
            return {
                label: "Jurídica",
                value: "JURIDICA",
            };
        }
    };

    console.log('customer', customer);

    const initialValues = {
        firstName: customer?.firstName || "",
        lastName: customer?.lastName || "",
        email: customer?.user?.email || "",
        municipalRegistration: customer?.municipalRegistration || null,
        stateRegistration: customer?.stateRegistration || null,
        gender: defaultGender(customer?.gender, customer?.entity),
        document: customer?.document || "",
        mobile: customer?.mobile || "",
        active: customer?.active || false,
        exempt: customer?.exempt || "",
        birthdate: convertToDayjs(customer?.birthdate) || "",
        entity: defaultEntity(customer?.entity),
        phone: customer?.phone || "",
        parentAdministrator: { value: customer?.parentAdministrator?.uuid, label: customer?.parentAdministrator?.name },
    };

    const handleSubmit = async (values: any) => {
        let response;

        const payload = {
            firstName: values?.firstName,
            lastName: values?.lastName,
            email: values?.email,
            municipalRegistration: values?.municipalRegistration,
            stateRegistration: values?.stateRegistration,
            gender: values?.gender?.value,
            document: values?.document,
            mobile: values?.mobile || null,
            exempt: values?.exempt === "" ? false : values.exempt,
            birthdate: values?.birthdate,
            entity: values?.entity?.value,
            active: values?.active,
            phone: values?.phone,
            user: {
                email: values?.email,
                password: values?.password,
                //@ts-ignore
                username: values?.email,
            },
        };

        if (values?.parentAdministrator?.value) {
            //@ts-ignore
            payload.parentAdministrator = {
                uuid: values.parentAdministrator.value,
            };
        }

        if (uuid) {
            response = await customerStore.editCustomer(payload, uuid);
        } else {
            const newPayload = {
                "@class": "br.com.stoom.horeca.model.persistence.HorecaCustomer",
                ...payload,
            };
            response = await customerStore.createCustomer(newPayload);
        }

        if (!response.error) listRouter();
    };

    const listRouter = () => {
        navigate(`/cliente`);
    };

    return (
        <>
            <Permission
                permissionKeys={[PermissionCustomer.POST, PermissionCustomer.PUT, PermissionCustomer.GET_UUID]}
                fallback={NotPermissionComponent()}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={!uuid ? validationSchema : validationEditSchema}
                >
                    {({ values, setFieldValue }) => {
                        return (
                            <Form>
                                <div>
                                    <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Cadastro de Clientes" description="Tela para cadastro de Clientes" actions={
                                        <>
                                            <SwitchComponent name="active" checkedChildren="Ativo" unCheckedChildren="Inativo" />
                                        </>
                                    }>
                                        <div className="grid grid-cols-12 gap-4 pb-4">
                                            <div className="col-span-4">
                                                <SelectComponent
                                                    label="Tipo de Cadastro*"
                                                    name="entity"
                                                    options={[
                                                        { label: "Física", value: "FISICA" },
                                                        { label: "Jurídica", value: "JURIDICA" },
                                                    ]}
                                                />
                                            </div>
                                            <div className="col-span-4">
                                                <InputComponent
                                                    label={
                                                        values?.entity?.value === "FISICA"
                                                            ? "Nome*"
                                                            : "Razão Social*"
                                                    }
                                                    name="firstName"
                                                    id="firstName"
                                                />
                                            </div>

                                            <div className="col-span-4">
                                                <InputComponent
                                                    label={
                                                        values?.entity?.value === "FISICA"
                                                            ? "Sobrenome"
                                                            : "Nome Fantasia"
                                                    }
                                                    name="lastName"
                                                    id="lastName"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-12 gap-4 pb-4">
                                            <div className="col-span-4">
                                                <InputComponent
                                                    disabled={uuid ? true : false}
                                                    label="E-mail*"
                                                    name="email"
                                                    id="email"
                                                />
                                            </div>

                                            <div className="col-span-4">
                                                {values?.entity?.value !== 'FISICA' && (
                                                    <InputMaskComponent
                                                        disabled={uuid ? true : false}
                                                        mask="99.999.999/9999-99"
                                                        maxLength={14}
                                                        label="Documento*"
                                                        name="document"
                                                        id="document"
                                                    />
                                                )}

                                                {values?.entity?.value === 'FISICA' && (
                                                    <InputMaskComponent
                                                        disabled={uuid ? true : false}
                                                        mask="999.999.999-99"
                                                        maxLength={11}
                                                        label="Documento*"
                                                        name="document"
                                                        id="document"
                                                    />
                                                )}
                                            </div>

                                            <div className="col-span-4">
                                                {values?.entity?.value === "FISICA" && (
                                                    <DatePickerComponet
                                                        label="Data de Nascimento"
                                                        name="birthdate"
                                                        isRange={false}
                                                    />
                                                )}

                                                {values?.entity?.value !== "FISICA" && (
                                                    <InputComponent
                                                        label="Inscrição Municipal"
                                                        name="municipalRegistration"
                                                        id="municipalRegistration"
                                                    />
                                                )}
                                            </div>
                                        </div>


                                        <div className="grid grid-cols-12 gap-4">
                                            {values?.entity?.value !== "FISICA" && (
                                                <>
                                                    <div className="flex col-span-4 gap-2 items-center">
                                                        <InputComponent
                                                            label="Inscrição Estadual"
                                                            name="stateRegistration"
                                                            id="stateRegistration"
                                                            disabled={values?.exempt}
                                                        />

                                                        <div className="pt-4">
                                                            <CheckboxComponent
                                                                label="Isento"
                                                                name="exempt"
                                                                id="exempt"
                                                                onChange={() => {
                                                                    setFieldValue("exempt", !values?.exempt);
                                                                    if (!values?.exempt) {
                                                                        setFieldValue("stateRegistration", null);
                                                                    } else {
                                                                        setFieldValue("stateRegistration", undefined);
                                                                    }
                                                                }}
                                                                checked={values?.exempt}
                                                            />
                                                        </div>
                                                    </div>
                                                </>)}

                                            {values?.entity?.value === "FISICA" && (
                                                <div className="col-span-4">
                                                    <SelectComponent
                                                        label="Gênero"
                                                        name="gender"
                                                        options={[
                                                            { label: "Feminino", value: "FEMININO" },
                                                            { label: "Masculino", value: "MASCULINO" },
                                                        ]}
                                                    />
                                                </div>
                                            )}

                                            <div className="col-span-4">
                                                <InputMaskComponent
                                                    mask="(99) 9999-9999"
                                                    maxLength={10}
                                                    label="Telefone"
                                                    name="phone"
                                                    id="phone"
                                                />
                                            </div>


                                            <div className="col-span-4">
                                                <InputMaskComponent
                                                    maxLength={11}
                                                    mask="(99) 9.9999-9999"
                                                    label="Celular"
                                                    name="mobile"
                                                    id="mobile"
                                                />
                                            </div>

                                            {!uuid && (
                                                <>
                                                    <div className="col-span-4">
                                                        <InputPassword
                                                            label="Senha"
                                                            name="password"
                                                            id="password"
                                                        />
                                                    </div>

                                                    <div className="col-span-4">
                                                        <InputPassword
                                                            label="Confirmar Senha"
                                                            name="confirmPassword"
                                                            id="confirmPassword"
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="pt-4">
                                            <SelectComponent
                                                label="Administrador Responsável"
                                                name="parentAdministrator"
                                                options={administratorSelect}
                                            />
                                        </div>
                                    </ContentBox>
                                </div>
                                <div className="flex justify-end">
                                    <Permission permissionKeys={[PermissionCustomer.PUT, PermissionCustomer.POST]} buttonType>
                                        <ActionButton htmlType="submit" actionType="primary">{uuid ? "Atualizar" : "Cadastrar"}</ActionButton>
                                    </Permission>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </Permission>
        </>
    );
});

export default FormCustomer;
